<h2 mat-dialog-title>Alterar conceito</h2>
<mat-dialog-content>
  <p>
    Informe a justificativa para alterar o conceito de <br /><strong>{{ data.nomeSocial || data.nome }}</strong
    >:
  </p>
  <mat-form-field appearance="outline" class="w-100-pct">
    <mat-label>Justificativa</mat-label>
    <mat-select [(ngModel)]="justificativa" required>
      <mat-option value="IV">
        IV- critério de desempate específico do edital da unidade, conforme item {{ itemEdital }} - IV.
      </mat-option>
      <mat-option value="V- candidato que tiver exercido a função de jurado nos termos da Lei Federal nº 11.689/2008.">
        V- candidato que tiver exercido a função de jurado nos termos da Lei Federal nº 11.689/2008.
      </mat-option>
      <mat-option value="Candidato não possui condições previstas no edital que o coloque em posição superior no desempate.">
        Candidato não possui condições previstas no edital que o coloque em posição superior no desempate.
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="justificativa === 'IV'">
    <p class="quote-box">
      Utilize esta justificativa junto com o item específico do edital da unidade relacionado ao critério de desempate.
    </p>
    <mat-form-field appearance="outline" class="w-100-pct">
      <mat-label>Justificativa</mat-label>
      <textarea matInput [(ngModel)]="descricaoJustificativa" maxlength="250" rows="3" required></textarea>
      <mat-hint align="end">{{ descricaoJustificativa.length || 0 }}/250 caracteres</mat-hint>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="confirmar()" [disabled]="!justificativa || (justificativa === 'IV' && !descricaoJustificativa.trim())">Atualizar</button>
</mat-dialog-actions>
